export class milestones{
  constructor(
    public _id: string,
    public title: string,
    public description: string
  ){
  }
}
